export const AUTHENTICATION_SET_TOKEN = 'AUTHENTICATION_SET_TOKEN';
export const AUTHENTICATION_CLEAR_TOKEN = 'AUTHENTICATION_CLEAR_TOKEN';
